/** @file Whether an applied plan is undone now: the feed decides once it holds a revert of its rev. */
import { undoneRevs, type RevertLink } from '@pose2d/api/queries/undoneRevs';
import type { AppliedView } from './autorigTypes';

/** A Mod+Z (or a redo) of the plan's commit shows on the banner (fx1 T-465); before any revert of it reaches the feed
 *  the session's own Undo state stands. */
export function appliedUndone(view: AppliedView, commits: readonly RevertLink[]): boolean {
  if (!commits.some((c) => c.revertOf === view.rev)) return view.undone;
  return undoneRevs(commits).has(view.rev);
}
